import React from 'react'

// use for retrieving the exact product info (e.g. images, name, etc)
export const ItemContext = React.createContext([]);


